import React from 'react';
import { Link } from 'react-router-dom';

export function Footer({ year }) {
  const links = [
    { to: '/home', label: 'Home' },
    { to: '/apps', label: 'Apps' },
    { to: '/websites', label: 'Websites' },
    { to: '/logos', label: 'Logos' },
    { to: '/print', label: 'Print Work' },
    { to: '/animation', label: 'Animation' },
    { to: '/3d', label: '3D Art' },
    { to: '/case-studies', label: 'Case Studies' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
    { to: '/illustration', label: 'Illustration' },
  ];

  return (
    <footer>
      <div id="bottombar">
        <div id="bottomlinks" align="center">
          <span>
            {links.map((link, i) => (
              <React.Fragment key={link.to}>
                <Link to={link.to}>{link.label}</Link>
                {i < links.length - 1 && '\u00A0\u00A0\u00A0\u00A0\u00A0'}
              </React.Fragment>
            ))}
          </span>
        </div>
      </div>

      Copyright &copy; 2001 - {year} by DraZtic ................. (All Rights Reserved)<br />
      Web Page Created: November 14, 2001<br />
      <br />
      All images (unless stated otherwise) created by DraZtic. All rights reserved. All artwork offering products and/or services were created for clients and business associates for products and/or advertising services. I have no control/input on the actual content/usage of the artwork created for these clients, and they themselves aren't affiliated with DraZtic.com. This also includes company logos, marketing, and advertising materials which belong to their respective owners. Please do not use images without permission. All non original/fan art characters copyright their respective owners.
    </footer>
  );
}
